module.exports = __webpack_public_path__ + "img/Github.d1bc12a5.png";